import { computed, type Ref, type WritableComputedRef } from 'vue';
import { normalizeStayCriteria } from '@/entities/searchCriteria';
import type { SearchFormCriteria } from '@/widgets/searchForm';
import { EMPTY_CRITERIA } from '../config/criteria';
import type { SerpPageProps } from '../model/types';

export function useSerpCriteria(
  props: Pick<SerpPageProps, 'modelValue'>,
  emit: (event: 'update:modelValue', criteria: SearchFormCriteria) => void,
  isStayCalendar?: Ref<boolean>,
): WritableComputedRef<SearchFormCriteria> {
  const getCriteria = (criteria: SearchFormCriteria): SearchFormCriteria =>
    isStayCalendar?.value ? normalizeStayCriteria(criteria) : criteria;

  return computed<SearchFormCriteria>({
    get: () => getCriteria(props.modelValue || EMPTY_CRITERIA),
    set: (value) => emit('update:modelValue', getCriteria(value)),
  });
}
